module.exports = "<div class=\"divider-group dg-md\"> <div class=row> <div class=col-xs-3> <div class=q-marg-vert-xxs> {%- updatedOn %} </div> </div> <div class=col-xs-2> <div class=q-marg-vert-xxs> {%- updatedBy %} </div> </div> <div class=col-xs-2> <div class=q-marg-top-xxxs> {%= statusPill %} </div> </div> <div class=col-xs-5> <div class=q-marg-vert-xxs> {%- description %} </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/orderHistoryRow.html
// module id = 1364
// module chunks = 1